import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import Sidebar from './component'

import { submitRound, lockScreen } from '../../../redux/game'

import { sections } from '../../../lib/get-sections'

class SidebarContainer extends PureComponent {
  handleSubmit = () => {
    this.props.submitRound(this.props.currentRound, this.props.teamId)
  }

  render () {
    let roundSetup = this.props.currentRoundSetup
    if (this.props.selectedRound !== this.props.currentRound) {
      roundSetup = this.props.roundsSetup.find(rs => rs.round === this.props.selectedRound)
    }
    return (
      <Sidebar
        minimised={this.props.minimised}
        activeItem={this.props.activeItem}
        sections={sections(roundSetup, this.props.isWrapUp)}
        sideBarFontSize={this.props.sideBarFontSize}
        sidebarWidth={this.props.sidebarWidth}
        showSignOffButton={this.props.isMaster && !this.props.isWrapUp}
        onSubmit={this.handleSubmit}
        lockScreen={this.props.lockScreen}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  minimised: state.ui.sidebarMinimised,
  activeItem: state.ui.currentTab,
  sidebarWidth: state.ui.sidebarWidth,
  sideBarFontSize: state.ui.sideBarFontSize,
  isMaster: state.device.isMaster,
  teamId: state.team.id,
  currentRound: state.game.currentRound,
  currentRoundSetup: state.game.currentRoundSetup,
  selectedRound: state.game.selectedRound,
  roundsSetup: state.game.roundsSetup,
  isWrapUp: state.game.state === 'wrapup'
})

export default connect(mapStateToProps, { submitRound, lockScreen })(SidebarContainer)
